import { Checkbox, FormControlLabel, Tooltip } from "@mui/material";
import { getRunIdFromPlateBarcode } from "helpers/plate-barcode-helpers";
import { useEffect } from "react";
import { GenericFieldProps } from "./FeedGroupFormRow";

export interface GenerateMystRackProps extends GenericFieldProps {
  value: boolean | undefined | null;
  plateBarcodes: string[];
  plateBarcodesLoaded: boolean;
  setFieldValue: (field: string, value: boolean) => void;
}

export const GenerateMystRack = ({
  index,
  toggleDisabled,
  handleBlur,
  value,
  plateBarcodes,
  plateBarcodesLoaded,
  setFieldValue,
}: GenerateMystRackProps) => {
  const fieldName = `feedGroupArray[${index}].generateMystRack`;
  const runIds = new Set(plateBarcodes.map(getRunIdFromPlateBarcode));

  const ineligibleReason = !plateBarcodesLoaded
    ? null
    : plateBarcodes.length === 0
    ? "Add plates to the feed group to have the option to generate a MYST rack"
    : runIds.size > 1
    ? "All plates in the feed group must be of the same Run ID to generate a MYST rack"
    : null;

  // Waits for getPlatesNoPaging to finish so a slow plates query can't wipe a saved value.
  useEffect(() => {
    if (value && ineligibleReason) setFieldValue(fieldName, false);
  }, [value, ineligibleReason, fieldName, setFieldValue]);

  return (
    <Tooltip title={ineligibleReason ?? ""}>
      <span>
        <FormControlLabel
          label="Generate MYST Rack during Feed"
          disabled={
            toggleDisabled || !plateBarcodesLoaded || !!ineligibleReason
          }
          control={
            <Checkbox
              name={fieldName}
              checked={!!value}
              onBlur={handleBlur}
              onChange={(e) => setFieldValue(fieldName, e.target.checked)}
            />
          }
        />
      </span>
    </Tooltip>
  );
};
